<div class="saved-queries-panel-container">
  <div class="cci-saved-queries-form-group">
    <h3>Saved Queries</h3>
  </div>

  <div class="cci-saved-queries-form-group">
    <div *ngIf="results === null">Loading...</div>
    <div *ngIf="results !== null">
      <div *ngIf="!results.length">No saved queries.</div>
      <div *ngIf="results.length">
        {{ results.length }} / {{ maxSavedQueries }} saved queries.
      </div>

      <table *ngIf="results.length" class="cci-table table table-striped table-bordered">
        <thead class="cci-header">
          <tr>
            <th class="cci-header-data">Nickname</th>
            <th class="cci-header-data">Actions</th>
          </tr>
        </thead>

        <tbody class="cci-body">
          <tr class="cci-row" *ngFor="let savedQuery of results; let i = index" [attr.data-index]="i">
            <td class="cci-row-data">
              <div class="cci-row-data-div cci-tooltip" title="{{savedQuery.nickname}}">
                {{savedQuery.nickname}}
              </div>
            </td>

            <td class="cci-row-data">
              <button (click)="load(i)">Load</button>
<!--              <button (click)="rename(i)">Rename</button>-->
              <button (click)="deleteModal(i)">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="cci-modal cci-saved-queries-save-modal" title="Save new query">
        <div>Please enter a nickname for this query:</div>
        <input type="text" [(ngModel)]="saveModalNickname" required>
      </div>

      <div class="cci-modal cci-saved-queries-delete-modal" title="Delete saved query">
        <div>You are about to permanently delete this saved query:</div>
        <div><strong>"{{ deleteModalNickname }}"</strong></div>
        <div>Are you sure?</div>
      </div>

    </div>

  </div>
</div>
